import { useContext } from "react";
import { Link } from "react-router-dom";
import UserData from "../UserData";
import {
  useCurrentUser,
  UserContext
} from "../../functional-components/UserContext";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { adminPagesUrl } from "../../config/urls";
import Icon from "../Icon";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import "./style.scss";

const AccountMenu = ({
  showCloseIcon = false,
  showMenuIcon = false,
  onMenuIconClick = () => {},
  afterLogout = () => {}
}) => {
  const userContext = useContext(UserContext);
  const { admin } = useCurrentUser();
  const t = useBjelinTranslations();
  const features = useSiteFeatures();

  const onTranslationsClick = e => {
    e.preventDefault();
    userContext.setTranslationAdminModeOn(value => !value);
  };

  return (
    <ul className="account-menu">
      <li>
        <div className="item header-item">
          <Link to={"/account"} className="content">
            <h2>{t("account.heading")}</h2>
            <p>
              <UserData />
            </p>
          </Link>
          <div className="icon" onClick={onMenuIconClick}>
            {showCloseIcon && <Icon name={"xmark"} />}
            {showMenuIcon && <Icon name={"bars"} />}
          </div>
        </div>
      </li>
      {features.login() && (
        <li>
          <Link
            id={"account-details-link"}
            to={"/account/edit"}
            className="item"
          >
            <div className="content">
              <h5>{t("account.details")}</h5>
              <p>{t("account.details.descr")}</p>
            </div>
            <div className="icon">
              <Icon name="circle-user" />
            </div>
          </Link>
        </li>
      )}
      {/*
        <li>
          <Link to={"/account/addresses"} className="item">
            <div className="content">
              <h5>{t("account.shipping")}</h5>
              <p>{t("account.shipping.descr")}</p>
            </div>
            <div className="icon">
              <Icon name="truck" />
            </div>
          </Link>
        </li>
      */}
      {features.login() && (
        <li>
          <Link to={"/account/orders"} className="item">
            <div className="content">
              <h5>{t("account.orders")}</h5>
              <p>{t("account.orders.descr")}</p>
            </div>
            <div className="icon">
              <Icon name="clock-rotate-left" />
            </div>
          </Link>
        </li>
      )}
      {admin && (
        <li>
          <Link to={adminPagesUrl} className="item">
            <div className="content">
              <h5>{t("account.admin")}</h5>
              <p>{t("account.admin.descr")}</p>
            </div>
            <div className="icon">
              <Icon name="user-shield" />
            </div>
          </Link>
        </li>
      )}
      {admin && (
        <li>
          <div className="item" onClick={onTranslationsClick}>
            <div className="content">
              <h5>
                {userContext.translationAdminModeOn ? "Göm" : "Visa"}{" "}
                översättningar
              </h5>
              <p>Visar keys från Lokalize</p>
            </div>
            <div className="icon">
              <Icon name="language" />
            </div>
          </div>
        </li>
      )}
      {features.login() && (
        <li>
          <Link to={"/account/faq"} className="item">
            <div className="content">
              <h5>{t("account.faq")}</h5>
              <p>{t("account.faq.descr")}</p>
            </div>
            <div className="icon">
              <Icon name="circle-info" />
            </div>
          </Link>
        </li>
      )}
      <li>
        <Link
          to={"/"}
          className="item logout-btn"
          onClick={() => {
            userContext.signOut().then(afterLogout);
          }}
        >
          <div className="content">
            <h5>{t("log.out")}</h5>
            <p />
          </div>
          <div className="icon">
            <Icon name={"arrow-right-from-bracket"} />
          </div>
        </Link>
      </li>
    </ul>
  );
};

export default AccountMenu;
